import { useEffect, useState } from "react";
import axios from "axios";
import { DataGrid, Progress } from "..";
import { Alert } from "@mui/material";

const renderResponse = (res) => {
  if (res.error) {
    return <Alert severity="error">{res.error}</Alert>;
  }
  if (!res.status) {
    return (
      <Alert severity="error">
        {res.errors.map((error) => (
          <div key={error.row}>
            <b>Error:</b> Row <b>{error.row}</b> Reason: <b>{error.message}</b>
          </div>
        ))}
      </Alert>
    );
  }

  const columns = Object.keys(res.fields).map((name) => ({
    field: name,
    headerName: name,
    flex: 1,
  }));

  return (
    <div>
      Rows in CSV: <b>{res.row_count}</b>
      <br />
      <h2>Detected Columns</h2>
      <DataGrid rows={res.results} columns={columns} />
    </div>
  );
};

export const DetectColumns = ({ selectedFile, setNextStepDisabled }) => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (!selectedFile) {
      setLoading(false);
      setResponse({ error: "Please select a file" });
      return;
    }

    if (!selectedFile.name.endsWith(".csv")) {
      setLoading(false);
      setResponse({ error: "Sorry, only CSV files are supported." });
      return;
    }

    const formData = new FormData();
    formData.append("upload", selectedFile, selectedFile.name);

    setLoading(true);
    axios
      .post(`${process.env.REACT_APP_BACKEND_API}/detectColumns`, formData)
      .then((response) => response.data)
      .then((data) => {
        setResponse(data);
        if (data.status) {
          setNextStepDisabled(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setResponse({ error: error.message });
      });
  }, [selectedFile, setNextStepDisabled]);

  if (loading) return <Progress text="Running Column Detection" />;

  return response ? renderResponse(response) : "";
};
